import CanHelpMeItemComplement from './CanHelpMeItemComplement'
import CanHelpMeItemDropDown from './CanHelpMeItemDropDown'
import CanHelpMeItemLink from './CanHelpMeItemLink'
import CanHelpMeLocation from './CanHelpMeLocation'

const CanHelpMeItem = ({ block }) => {
    return block?.childrens?.map((block, index) => (
        <div key={index} className="baseocom-content-item">
            <CanHelpMeItemComplement block={block} />
            <CanHelpMeItemDropDown block={block} />
            <CanHelpMeItemLink block={block} />
            <CanHelpMeLocation block={block} />
        </div>
    ))
}

export default CanHelpMeItem
